import * as propertyTypes from "../property_types.js"

export class UiGrid extends propertyTypes.AppBaseComponentProps {

    private gridEditorDropDownListsMetadata = new propertyTypes.TextProperty("gridEditorDropDownLists", "Grid editor dropdown lists");
    public gridEditorDropDownLists: string;

    private gridOptionsMetadata = new propertyTypes.TextProperty("gridOptions", "Grid options");
    public gridOptions: string;

    private schemaMetadata = new propertyTypes.TextProperty("schema", "Schema");
    public schema: string;

    private pageSizeMetadata = new propertyTypes.TextProperty("pageSize", "Page size");
    public pageSize: boolean;

    private mapMetadata = new propertyTypes.TextProperty("map", "Map");
    public map: string;

    private searchButtonEnabledMetadata = new propertyTypes.CheckBoxProperty("searchButtonEnabled", "Search button enabled");
    public searchButtonEnabled: string;

    private searchWindowTitleMetadata = new propertyTypes.TextProperty("searchWindowTitle", "Search window title");
    public searchWindowTitle: string;

    private searchWindowUrlMetadata = new propertyTypes.TextProperty("searchWindowUrl", "Search window url");
    public searchWindowUrl: string;

    private styleMetadata = new propertyTypes.TextProperty("style", "Style");
    public style: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.gridEditorDropDownListsMetadata, this.gridOptionsMetadata, this.schemaMetadata, this.pageSizeMetadata, this.mapMetadata, this.searchButtonEnabledMetadata, this.searchWindowTitleMetadata, this.searchWindowUrlMetadata, this.styleMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}